<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    v-model="dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded class="secondary ml-4" small v-bind="attrs" v-on="on">
        Create Subscription
      </v-btn>
    </template>
    <template v-slot:default="dialog">
      <v-card>
        <v-card-text class="pt-4">
          <v-row class="my-4">
            <v-col cols="12" class="text-center">
              <h2 class="steptext">Please Select Package</h2>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                v-model="selectedPackage"
                :items="selectPackage"
                label="Please Select Package"
                item-text="text"
                item-value="value"
                class="selectpackage"
              ></v-select>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                class="compeatsecondary mr-2 white--text"
                rounded
                small
                @click="closeDialog()"
              >
                Close
              </v-btn>
              <v-btn
                class="primary ml-2"
                rounded
                @click="goToPackagePage()"
                small
                >Continue</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  props:['selectPackage'],
  data: () => ({
    dialog: false,
    selectedPackage: "",
  }),
  methods:{
    goToPackagePage(){
        if(this.selectedPackage === 'package-1'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-1',
                },
            });
        }else if(this.selectedPackage === 'package-2'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-2',
                },
            });
        }else if(this.selectedPackage === 'package-3'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-3',
                },
            });
        }else if(this.selectedPackage === 'package-1-trial'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-1-trial',
                },
            });
        }else if(this.selectedPackage === 'package-2-trial'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-2-trial',
                },
            });
        }else if(this.selectedPackage === 'package-3-trial'){
            this.$router.push({
                name: "createSingleSubscription",
                params: {
                title: 'package-3-trial',
                },
            });
        }
        // else if(this.selectedPackage === 'package-demo'){
        //     this.$router.push({
        //         name: "createSingleSubscription",
        //         params: {
        //         title: 'package-demo',
        //         },
        //     });
        // }
    },
    //open and close dialog
    closeDialog() {
      this.dialog = false;
    },
  }
};
</script>
